/**
 * HTML escaping utility to prevent XSS attacks
 * All user-controlled content rendered in templates must be escaped
 */
/**
 * Escape HTML special characters to prevent XSS
 * Use this for any user-controlled text rendered in innerHTML templates
 */
export function escapeHtml(text) {
    if (!text)
        return '';
    return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}
